export function filterType(type, source, done) {
    const filtered = source.filter(json => json.type === type)
    if (filtered.length > 0) done(filtered)
}